import addSpaceToNumber from "./format-number"

const $cylTopFirst = $("[data-profit=cyl-top-blue-first]")
const $cylMidFirst = $("[data-profit=cyl-mid-blue-first]")
const $cylTopSecond = $("[data-profit=cyl-top-blue-second]")
const $cylMidSecond = $("[data-profit=cyl-mid-blue-second]")
const $cylAddition = $("[data-profit=cyl-addition]")
const $cylSumSecond = $("[data-profit=cyl-sum-second]")
const $cylSumThird = $("[data-profit=cyl-sum-third]")
const $cylMobileTopFirst = $("[data-profit=cyl-mobile-top-blue-first]")
const $cylMobileMidFirst = $("[data-profit=cyl-mobile-mid-blue-first]")
const $cylMobileTopSecond = $("[data-profit=cyl-mobile-top-blue-second]")
const $cylMobileMidSecond = $("[data-profit=cyl-mobile-mid-blue-second]")
let cylSum

const countPercentCylBlueFirst = (number) => {
  cylSum = Math.round(parseInt(number) * (7.8 / 100) + parseInt(number))
  $cylSumSecond.text(addSpaceToNumber(cylSum))
}

const countPercentCylBlueSecond = (number) => {
  cylSum = Math.round(parseInt(number) * (15.1 / 100) + parseInt(number))
  $cylSumThird.text(addSpaceToNumber(cylSum))
}

export const cylStateOneBlue = (MIN_VAL) => {
  countPercentCylBlueFirst(MIN_VAL)
  countPercentCylBlueSecond(MIN_VAL)

  $cylAddition.css({
    transform: `translateY(-40px)`,
  })

  $cylMobileTopFirst.css({
    transform: `translateX(127px)`,
  })

  $cylMobileMidFirst.css({
    transform: `scaleX(134)`,
  })
}

export const cylStateTwoBlue = (MAX_VAL) => {
  countPercentCylBlueFirst(MAX_VAL)
  countPercentCylBlueSecond(MAX_VAL)
}

export const cylStateThreeBlue = (inputVal, growStep) => {
  countPercentCylBlueFirst(inputVal)
  countPercentCylBlueSecond(inputVal)

  $cylAddition.css({
    transform: `translateY(-${40 + growStep}px)`,
  })

  $cylMobileTopFirst.css({
    transform: `translateX(${127 + growStep}px)`,
  })

  $cylMobileMidFirst.css({
    transform: `scaleX(${134 + growStep})`,
  })

  $cylMobileTopSecond.css({
    transform: `translateX(${207 + growStep}px)`,
  })

  $cylMobileMidSecond.css({
    transform: `scaleX(${214 + growStep})`,
  })
}

export const cylBlueAnimation = () => {
  $cylTopFirst.css({
    animation: "jelly-barrels-blue-top-first 2s 1s",
  })
  $cylMidFirst.css({
    animation: "jelly-barrels-blue-middle-first 2s 1s",
  })
  $cylTopSecond.css({
    animation: "jelly-barrels-blue-top-second 2s 1s",
  })
  $cylMidSecond.css({
    animation: "jelly-barrels-blue-middle-second 2s 1s",
  })

  setTimeout(() => {
    $cylTopFirst.css({
      animation: "",
    })
    $cylMidFirst.css({
      animation: "",
    })
    $cylTopSecond.css({
      animation: "",
    })
    $cylMidSecond.css({
      animation: "",
    })
  }, 3000)
}



// WEBPACK FOOTER //
// ./src/blocks/barrels/cyl-blue.js